import { DateTime, Interval } from 'luxon';
import { IEpisode } from 'src/app/core/services/extended-program-guide.service';

export interface IProgramDayGroup {
  day: Interval;
  /**
   * Items in the day. It contains information about the program,
   * and the range of the program.
   */
  items: IProgramDayGroupItem[];
}

export interface IProgramDayGroupItem {
  program: IEpisode;
  /**
   * Start and end date of the episode
   */
  range: Interval;
}

export default function generateDayScheduleMap(
  programs: ReadonlyArray<IEpisode>
) {
  let startDate: DateTime;
  let dayStart: DateTime;
  let range: Interval;
  let day: Interval;
  const dayScheduleMap = new Map<number, IProgramDayGroup>();

  for (const program of programs) {
    startDate = DateTime.fromSeconds(program.start_date);

    /**
     * Episode range
     */
    range = Interval.after(startDate, { minutes: program.duration });

    /**
     * Start date of the day the episode is in
     */
    dayStart = startDate.startOf('day');

    /**
     * If the schedule is not in the map yet, create it
     */
    let schedule = dayScheduleMap.get(dayStart.toSeconds());

    if (!schedule) {
      /**
       * Create current episode day interval
       */
      day = Interval.fromDateTimes(dayStart, dayStart.endOf('day'));

      schedule = {
        day,
        items: []
      };
      dayScheduleMap.set(dayStart.toSeconds(), schedule);
    }

    schedule.items.push({
      program,
      range
    });
  }

  return dayScheduleMap;
}
